export default __webpack_public_path__ + "static/taskworld-822d7010905840a96bec39806ccba78f.png";